import {applyMiddleware, createStore} from "redux";
import { BOOKSUBMIT , REMOVEFLIGHT } from "./form/actionTypes";
import formReducer from "./form/formReducer";

const myMiddleware = (store) => (next) => action =>{
    const state = store.getState();
    if(action.type === BOOKSUBMIT) {        
        if(state.ticket.length < 3){            
            return next(action);
        }   
    }
    if(action.type === REMOVEFLIGHT) {
        return next(action)
    }
}

const store = createStore(formReducer, applyMiddleware(myMiddleware));

export default store;